var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('iframe',{ref:"appCenter",staticClass:"app-center",attrs:{"src":_vm.link,"scrolling":"no","frameborder":"0","width":"100%","height":"1500"},on:{"load":_vm.loadIframe}})])}
var staticRenderFns = []

export { render, staticRenderFns }